module.exports = __webpack_public_path__ + "static/media/HOMEPAY.f8b75bcd.svg";